import * as yup from 'yup';
// @ts-ignore
// eslint-disable-next-line import/prefer-default-export
export const PaymentMethodValidation = yup.object().shape({
  name: yup.string().max(50).required(),
  address_1: yup.string().max(60).required(),
  address_2: yup.string().max(60).nullable(),
  city: yup.string().max(40).required(),
  state: yup.string().length(2).required(),
  country: yup.string().length(2).required(),
  zip: yup.string().max(20).required(),
});
